import React from 'react';
import { FormData, LIQUID_TYPE_LABELS } from '../types/aircraft';
import './RequestSummary.css';

interface RequestSummaryProps {
  formData: FormData;
}

const RequestSummary: React.FC<RequestSummaryProps> = ({
  formData
}) => {
  return (
    <div className="request-summary">
      <h3>Сводка заявки</h3>
      
      <div className="summary-content">
        <div className="summary-item">
          <strong>Название:</strong> {formData.title || 'Не указано'}
        </div>
        
        {formData.description && (
          <div className="summary-item">
            <strong>Описание:</strong> {formData.description}
          </div>
        )}
        
        {formData.liquidType && (
          <div className="summary-item">
            <strong>Тип жидкости:</strong> {LIQUID_TYPE_LABELS[formData.liquidType as keyof typeof LIQUID_TYPE_LABELS]}
          </div>
        )}
        
        {formData.aircraftParts && formData.aircraftParts.length > 0 && (
          <div className="summary-item">
            <strong>Части самолета:</strong>
            <ul className="aircraft-parts-list">
              {formData.aircraftParts.map((part, index) => (
                <li key={index}>
                  {part.aircraftPartName}
                  {part.description && <span className="part-description"> - {part.description}</span>}
                </li>
              ))}
            </ul>
          </div>
        )}
        
        <div className="summary-item">
          <strong>Приоритет:</strong> {
            formData.priority === 'LOW' ? 'Низкий' :
            formData.priority === 'MEDIUM' ? 'Средний' :
            formData.priority === 'HIGH' ? 'Высокий' : 'Не указан'
          }
        </div>
      </div>
    </div>
  );
};

export default RequestSummary; 